export default __webpack_public_path__ + "static/media/G.f3bcf3d8.png";